if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.submitButton = this.querySelector('[type="submit"]');

        if (!this.submitButton) return;

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart = document.querySelector("cart-drawer");
        if (document.querySelector("cart-drawer")) this.submitButton.setAttribute("aria-haspopup", "dialog");
        this.hideErrors = this.dataset.hideErrors === "true";

        this.cartLimit = this.dataset.cartLimit;
        if (this.cartLimit) {
          this.cartLimit = parseInt(this.cartLimit);
          this.checkCartLimit();
        }
      }

      checkCartLimit() {
        if (!this.cartLimit) return;

        const buttonTextEl = this.submitButton.querySelector("span");

        if (!buttonTextEl.textContent.includes(this.submitButton.dataset.defaultText) && !buttonTextEl.textContent.includes(this.submitButton.dataset.maxAddedText)) return;

        fetch('/cart.js', { cache: 'no-store' })
        .then(response => response.json())
        .then(cart => {
          const cartItems = cart.items;
          const matchingItems = cartItems.filter(item => item.product_id === parseInt(this.dataset.productId));
          const productTotal = matchingItems.reduce((acc, item) => acc + item.quantity, 0);

          if (productTotal >= this.cartLimit) {
            buttonTextEl.textContent = this.submitButton.dataset.maxAddedText;
            this.submitButton.setAttribute("aria-disabled", true);
            this.submitButton.disabled = true;
          } else {
            buttonTextEl.textContent = this.submitButton.dataset.defaultText;
            if (this.submitButton.dataset.soldOut === "true") return;
            this.submitButton.removeAttribute("aria-disabled");
            this.submitButton.disabled = false;
          }
        })
        .catch(error => console.error('Error fetching cart:', error));
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        let productGroup = this.closest(".product")?.querySelector("product-group");

        if (productGroup) {
          let productGroupCurrent = productGroup.dataset.selectedType;
          let productGroupCurrentItem = productGroupCurrent.split(":");
          let productGroupType = productGroupCurrentItem[0].trim();
          let productGroupData = productGroupCurrentItem[1].trim();

          formData.set(`[properties][${productGroupType}]`, productGroupData);
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty")) this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add("hidden");

            // custom event handling adding a free gift (free-gift-code.liquid)
            const addToCartEvent = new CustomEvent("itemAddedToCart", { detail: { id: formData.get("id") } });
            document.dispatchEvent(addToCartEvent);

            // disable button if cart limit is reached
            this.checkCartLimit();
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message");

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
